import { AddPhotoAlternate } from '@mui/icons-material';
import { Avatar, Button, CircularProgress } from '@mui/material';
import React from 'react';
import { CustomAvatar } from './CustomAvatar';

type TalentAvatarProps = {
  handleInputUploadImage: (e: React.ChangeEvent<HTMLInputElement>) => void,
  alt: string,
  profileImage: string,
  isLoading: boolean,
  isDisabled: boolean,
  width?: number,
  height?: number,
};

const style = {
  boxRow: {
    display: 'flex',
    marginBottom: '10px',
    alignItems: 'center',
  },
  textField: {
    variant: 'outlined',
    field: {
      // color: '#fff',
      width: 180,
      gap: 15,
      flex: 1,
      flexGrow: 1,
    },
  },
  emptyStateIcon: {
    borderRadius: '50%',
    sx: {
      bgColor: 'primary.main',
    },
  },
  width: 64,
  height: 64,
  fontSize: 25,
  disable: {
    pointerEvents: 'none',
  },
  normal: {
    pointerEvents: 'all',
  },
} as const;

export const UploadImage = (
  {
    alt,
    profileImage,
    isLoading,
    handleInputUploadImage,
    isDisabled,
    width,
    height,
  }: TalentAvatarProps): JSX.Element => {
  const renderAvatar = ():React.ReactNode => {
    if (!isLoading) {
      return (
        profileImage?.length > 0 ? (
          <CustomAvatar
            src={ profileImage }
            alt={ alt }
            width={ width }
            height={ height }
          />
        ) : (
          <Avatar
            alt="aleternate"
            sx={ {
              width,
              height,
            } }
            src=""
          >
            <AddPhotoAlternate
              sx={ {
                color: style.emptyStateIcon.sx.bgColor,
                borderRadius: style.emptyStateIcon.borderRadius,
                fontSize: style.fontSize,
              } }
            />
          </Avatar>
        )
      );
    }

    return <CircularProgress />;
  };

  return (
    <form
      style={ isDisabled ? style.disable : style.normal  }
      name="file"
      encType="multipart/form-data"
    >
      <Button
        style={ { background: 'unset', padding: 'unset', paddingRight: 16 } }
        variant="contained"
        component="label"
      >

        <input
          type="file"
          accept="image/*"
          onChange={ handleInputUploadImage }
          hidden
          disabled={ isDisabled }
        />
        {renderAvatar()}
      </Button>
    </form>
  );
};

UploadImage.defaultProps = {
  width: 64,
  height: 64,
};
